export const textIncludesSearchTerm = (text, searchTerm) => {
    if (!searchTerm || !text) {
        return false;
    }
    else {
        return text.toLowerCase().includes(searchTerm.toLowerCase());
    }
};